import MarketingPage from "../components/MarketingPage";
import { APP_STORE_URL, ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema } from "../lib/seo";

export default function DigitalCloset() {
  return (
    <MarketingPage
      seo={{
        title: "Digital Closet & AI Outfit Planner | C-STYL",
        description: "Turn the clothes you already own into a searchable digital closet. Add, upload, scan your wardrobe or import from receipts — then plan, track and create outfits.",
        path: "/digital-closet",
        testid: "digital-closet-page",
        jsonLd: [ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Digital Closet", path: "/digital-closet" }])],
      }}
      crumb="Digital Closet"
      eyebrow="Your wardrobe, digitized"
      h1="Turn Your Wardrobe Into a Digital Closet"
      lead="Turn the clothes you already own into a searchable digital closet, organized and ready before you are."
      sections={[
        { h2: "Ways to add your clothes", bullets: ["Take a photo", "Upload clothing", "Upload multiple photos at once", "Scan your wardrobe from one photo", "Import from a receipt (link, text or photo)", "Capture a piece with Spotted a Look", "Add manually"] },
        { h2: "AI tagging", p: ["Items are auto-tagged by category, colour and season, so your closet is searchable and filterable from day one. You review detected items before they're saved."] },
        { h2: "Favourites and feedback", p: ["Mark favourites and log how often you wear pieces. These signals help C-STYL personalize future recommendations."] },
        { h2: "Create and plan outfits", bullets: ["Build looks with Mix & Match", "Save outfits you love", "View your outfit history", "Track what you've worn", "Schedule outfits for tomorrow, in 3 days, or the weekend"] },
      ]}
      cta={{ label: "Download C-STYL", href: APP_STORE_URL, external: true }}
    />
  );
}
